{
  "dashboard": {
    "place": {
      "inShift": "الآن في {{clinic}} · حتى {{end}}",
      "between": "المناوبة التالية: {{clinic}} · {{start}}",
      "beforeFirst": "اليوم: {{clinic}} من {{start}}",
      "done": "انتهت مناوبة اليوم · {{clinic}}",
      "overlap": "مجدول في {{count}} عيادات في الوقت نفسه",
      "noShiftToday": "لا توجد ساعات حضور مسجلة لليوم",
      "noShiftDay": "لا توجد ساعات حضور مسجلة لهذا اليوم",
      "noShiftHint": "العيادة هي التي تسجل ساعات حضورك",
      "otherDay": "{{weekday}}: {{clinic}} {{hours}}",
      "more": "و{{count}} أخرى",
      "aria": "مكان عملك حسب جدول الحضور"
    },
    "stats": {
      "total": "موعد",
      "waiting": "بالانتظار",
      "completed": "تمت",
      "cancelled": "ملغى",
      "aria": "{{total}} موعد، {{waiting}} بالانتظار، {{completed}} تمت معاينتهم، {{cancelled}} ملغى",
      "share": "الحصة: {{amount}}",
      "shareNoFigure": "الحصة"
    },
    "week": {
      "title": "اختر يومًا",
      "thisWeek": "هذا الأسبوع",
      "nextWeek": "الأسبوع القادم",
      "prevWeek": "الأسبوع الماضي",
      "range": "{{from}} – {{to}}",
      "fullCalendar": "التقويم الكامل",
      "backToWeek": "العودة إلى الأسبوع",
      "countAria": "{{count}} مواعيد"
    },
    "clinic": {
      "auto": "تلقائي — حسب جدول الحضور",
      "autoSub": "العيادة التي يحددها جدولك لهذا اليوم",
      "autoBadge": "تلقائي"
    },
    "book": {
      "open": "موعد جديد",
      "title": "حجز موعد",
      "clinic": "العيادة",
      "patient": "المريض",
      "searchLabel": "البحث عن مريض",
      "searchPlaceholder": "الاسم أو رقم الهاتف أو الرقم الوطني",
      "searchHint": "أدخل حرفين على الأقل.",
      "noMatch": "لا يوجد مريض مطابق في قائمتك.",
      "truncated": "تُعرض أول {{count}} نتيجة فقط؛ ضيّق البحث.",
      "newPatient": "مريض جديد",
      "pickExisting": "اختيار من المرضى",
      "change": "تغيير",
      "name": "الاسم الكامل",
      "phone": "رقم الجوال",
      "nationalId": "الرقم الوطني (اختياري)",
      "when": "التاريخ والوقت",
      "duration": "مدة الموعد",
      "minutes": "{{count}} دقيقة",
      "note": "ملاحظة (اختياري)",
      "submit": "حجز الموعد",
      "submitRequest": "إرسال لموافقة العيادة",
      "readOnlyTitle": "للقراءة فقط — انتهى اشتراك العيادة",
      "readOnly": "انتهى اشتراك هذه العيادة ولوحتها للقراءة فقط؛ لا يمكن حجز موعد فيها أو نقله حتى تجدد العيادة اشتراكها. عياداتك الأخرى غير متأثرة.",
      "readOnlyOption": "{{name}} (للقراءة فقط)",
      "needsApprovalTitle": "بحاجة إلى موافقة العيادة",
      "needsApproval": "المواعيد التي تحجزها في هذه العيادة لا تصبح نهائية إلا بعد تأكيد الاستقبال، وتبقى حتى ذلك الحين «بانتظار تأكيد العيادة».",
      "booked": "تم حجز الموعد.",
      "requested": "أُرسل الموعد إلى العيادة للموافقة.",
      "loadFailed": "تعذّر تحميل قائمة العيادات.",
      "noClinic": "لا يمكنك حجز مواعيد في أي عيادة حاليًا.",
      "searchFailed": "تعذّر البحث عن المريض.",
      "modeFirstDay": "أول موعد في هذا اليوم",
      "modeFirstToday": "أول موعد اليوم",
      "modeManual": "اختيار الوقت",
      "showTimeOptions": "تغيير اليوم أو طريقة اختيار الوقت",
      "hideTimeOptions": "إخفاء خيارات الوقت",
      "noneLeftToday": "لم تعد هناك مواعيد شاغرة اليوم.",
      "finding": "جارٍ إيجاد أقرب موعد شاغر…",
      "bookThisOne": "احجزه",
      "firstFree": "أول موعد شاغر",
      "exactAtBooking": "يتحدَّد الوقت بدقة عند الحجز.",
      "firstSlotFailed": "تعذّر إيجاد أقرب موعد شاغر. يمكنك اختيار الوقت بنفسك.",
      "lessOptions": "إخفاء الخيارات الإضافية",
      "typeInPerson": "حضوري",
      "typeOnline": "عن بُعد",
      "submitFirst": "حجز أول موعد",
      "walkIn": "خارج الدور الآن",
      "walkInOff": "المريض حاضر الآن؛ يُضاف إلى دور اليوم دون تحديد وقت.",
      "walkInOn": "يُسجَّل دون وقت ويُضاف المريض الآن إلى دور اليوم.",
      "walkInOnShort": "دون وقت؛ يُضاف إلى دور اليوم.",
      "walkInLead": "لا توجد مواعيد شاغرة اليوم؛ أضف المريض الآن إلى دور اليوم دون وقت.",
      "walkInLeadShort": "دون وقت، إلى دور اليوم.",
      "walkInNoGrant": "في هذه العيادة تنتظر حجوزاتك تأكيد الاستقبال؛ المريض الحاضر يسجّله استقبال العيادة.",
      "walkInNoGrantShort": "في هذه العيادة الاستقبال فقط يسجّل خارج الدور.",
      "alreadyOpen": {
        "scheduled": "لهذا المريض موعد آخر اليوم لم يحضر بعد.",
        "arrived": "هذا المريض في دور اليوم الآن — هل يلزم موعد ثانٍ؟",
        "in_visit": "هذا المريض في زيارة الآن — هل يلزم موعد ثانٍ؟"
      },
      "submitWalkIn": "تسجيل وإضافة إلى الدور",
      "walkInBooked": "تمت إضافة المريض إلى دور اليوم.",
      "mode": "طريقة اختيار الوقت",
      "day": "اليوم",
      "visitType": "نوع الزيارة",
      "moreOptions": "خيارات إضافية (نوع الزيارة، المدة، الملاحظة)",
      "noneThisDay": "لا يوجد لديك موعد شاغر في هذا اليوم.",
      "nextIs": "أقرب موعد شاغر لديك:",
      "noneIn30Days": "لم يُعثر على موعد شاغر في الثلاثين يومًا القادمة أيضًا.",
      "slotAt": "{{date}}، الساعة {{time}}",
      "errors": {
        "clinic": "اختر العيادة.",
        "patient": "اختر المريض.",
        "name": "أدخل اسم المريض.",
        "phone": "رقم الجوال غير صالح.",
        "nationalId": "الرقم الوطني غير صالح.",
        "when": "أدخل تاريخ الموعد ووقته.",
        "past": "هذا الوقت قد مضى.",
        "noSlot": "لا يوجد موعد شاغر في هذا اليوم؛ اختر يومًا آخر أو أدخل الوقت يدويًا.",
        "phoneShared": "لهذا الرقم ملفات أخرى؛ اختر أحدها أو اضغط «مريض جديد بالرقم نفسه»."
      },
      "searchPickClinic": "اختر العيادة أولاً للبحث عن مرضاها.",
      "phoneCandidates": {
        "title": "الملفات المسجّلة بهذا الرقم: {{count}}",
        "hint": "هل الشخص أمامك أحد هؤلاء؟ اخترْه. وإن كان شخصاً آخر بالرقم نفسه (كأحد أفراد العائلة) فاضغط «مريض جديد بالرقم نفسه».",
        "choose": "اختيار",
        "sharedNote": "سيُسجَّل مريض جديد برقم تحمله ملفات أخرى.",
        "showAgain": "عرض الملفات",
        "inClinic": "ضمن قائمة هذه العيادة",
        "conflictOnSubmit": "هذا الرقم سُجِّل للتوّ في ملف آخر؛ راجع القائمة.",
        "lookupFailed": "تعذّر فحص الملفات المسجّلة بهذا الرقم. حاول مرة أخرى.",
        "checking": "جارٍ التحقق من ملفات هذا الرقم…",
        "checkFailed": "تعذّر التحقق من ملفات هذا الرقم؛ سيُعاد التحقق عند تسجيل الموعد."
      }
    },
    "phones": {
      "more": "أرقام أخرى: {{count}}",
      "otherLine": "{{relation}}: {{phone}}"
    },
    "withdraw": {
      "action": "إلغاء الطلب",
      "title": "إلغاء طلب الموعد",
      "message": "هل تريد إلغاء طلب موعد {{name}}؟ سيُحذف من قائمة العيادة.",
      "confirm": "إلغاء الطلب",
      "keep": "تراجع",
      "failed": "تعذّر إلغاء الطلب."
    },
    "reschedule": {
      "current": "الوقت الحالي: {{when}}",
      "newTime": "الوقت الجديد",
      "hint": "يُنقل الموعد ولا يُلغى ثم يُحجز من جديد، فتبقى فاتورته ودفعته كما هي.",
      "moved": "نُقل الموعد إلى {{when}}."
    },
    "edit": {
      "untimedCurrent": "خارج الدور — بلا وقت بعد",
      "setTimeHint": "حدّد وقت هذا الموعد؛ لن تُرسل رسالة إلى المريض.",
      "action": "تعديل الموعد",
      "title": "تعديل الموعد",
      "submit": "حفظ التغييرات",
      "type": "نوع الزيارة",
      "inPerson": "حضوري",
      "online": "عبر الإنترنت",
      "typeHint": "يتغيّر نوع الزيارة فقط؛ ويبقى سعرها كما حُجزت.",
      "typeLocked": {
        "over": "انتهت هذه الزيارة ولم يعد بالإمكان تغيير نوعها.",
        "notConfigured": "الزيارات عبر الإنترنت غير مفعّلة في هذا النظام."
      },
      "timeLocked": {
        "status": "لا يُنقل إلا الموعد الذي ما زال بانتظار مراجعة المريض؛ فقد حضر هذا المريض أو بدأت زيارته.",
        "grant": "في هذه العيادة تُؤكَّد مواعيدك عبر الاستقبال؛ اترك نقل هذا الموعد لاستقبال العيادة.",
        "untimed": "هذا موعد بلا وقت محدد، فلا يوجد وقت لتغييره."
      },
      "note": "ملاحظة الموعد"
    },
    "rowOps": {
      "more": "إجراءات أخرى لـ {{name}}",
      "next": "التالي في الدور",
      "backToRoom": "العودة إلى العيادة",
      "note": "ملاحظة الموعد",
      "nextAppt": "الموعد التالي",
      "noShow": "عدم الحضور",
      "cancel": "إلغاء الموعد",
      "cancelled": "أُلغي موعد {{name}}.",
      "cancelTitle": "إلغاء الموعد",
      "cancelMessage": "سيُلغى موعد {{name}} في الساعة {{time}}. لا يمكن التراجع عن ذلك.",
      "cancelConfirm": "نعم، ألغِ الموعد",
      "noShowTitle": "تسجيل عدم الحضور",
      "noShowMessage": "سيُسجَّل عدم الحضور لموعد {{name}} في الساعة {{time}}.",
      "noShowConfirm": "تسجيل عدم الحضور",
      "noteTitle": "ملاحظة الموعد",
      "noteLabel": "ملاحظة لموعد {{name}}",
      "noteHint": "يرى استقبال العيادة هذه الملاحظة أيضًا. اتركها فارغة لحذفها.",
      "noteSave": "حفظ الملاحظة",
      "errors": {
        "hasPayment": "سُجّل دفع لهذا الموعد؛ إلغاؤه من مهام استقبال العيادة.",
        "needsGrant": "في هذه العيادة يتولى الاستقبال إلغاء المواعيد وتسجيل عدم الحضور.",
        "paymentCheck": "تعذّر التحقق من حالة الدفع لهذا الموعد؛ حاول مرة أخرى.",
        "readOnly": "انتهى اشتراك هذه العيادة ولوحتها للقراءة فقط؛ لا يمكن إجراء هذا التغيير حتى يُجدَّد الاشتراك.",
        "gone": "لم يعد هذا الموعد موجودًا؛ حُدّثت القائمة.",
        "next": "تعذّر جعل هذا المريض التالي.",
        "cancel": "تعذّر إلغاء الموعد.",
        "noShow": "تعذّر تسجيل عدم الحضور.",
        "note": "تعذّر حفظ الملاحظة."
      }
    }
  },
  "nav": {
    "mobile": {
      "more": "المزيد",
      "moreTitle": "المزيد",
      "account": "الحساب",
      "sections": "الأقسام",
      "balance": "رصيد {{coin}}"
    }
  }
}
